import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from 'react-intl';
import {Form} from 'formik';
import FieldInput from '../../components/FieldInput';
import FieldCheckbox from '../../components/FieldCheckbox';
import FieldRadiobutton from '../../components/FieldRadiobutton';
import Button from '../../components/Button';
import ErrorValidation from '../../components/ErrorValidation';
import styles from './styles.module.scss';

const Step11View = ({values, isValid}) => {
  const anotherIncomePlaceholder = useIntl().formatMessage({
    id: 'step11.form.additionalIncome.another.input.placeholder',
    defaultMessage: 'Free writing'
  });

  return (
    <Form className={styles.formContainer}>
      <div className={`${styles.input} ${styles.innerPadding}`}>
        <div className={`${styles.input} ${styles.titleBold}`}>
          <FormattedMessage
            id='step11.form.otherIncomes.title'
            defaultMessage='Other incomes'
          />
        </div>
        <FieldRadiobutton
          fieldId={'otherIncomeExists'}
          value={'noIncomes'}
          label={(
            <FormattedMessage
              id='step11.form.otherIncomes.radio.noOtherIncome'
              defaultMessage='I have no other income including scholarships'
            />
          )}
          containerStyles={styles.input}
        />
        <FieldRadiobutton
          fieldId={'otherIncomeExists'}
          value={'otherIncomes'}
          label={(
            <FormattedMessage
              id='step11.form.otherIncomes.radio.otherIncome'
              defaultMessage='I have other income'
            />
          )}
          containerStyles={styles.input}
        />
      </div>
      {
        values.otherIncomeExists === 'otherIncomes' && (
          <>
            <div>
              <div className={`${styles.contentBlock} ${styles.title}`}>
                <FormattedMessage
                  id='step11.form.additionalIncome.title'
                  defaultMessage='Details of additional income'
                />
              </div>
              <div className={styles.contentBlock}>
                <FieldCheckbox
                  fieldId={'monthlyIncome'}
                  label={(
                    <div className={styles.text}>
                      <FormattedMessage
                        id='step11.form.additionalIncome.monthlySalary.label'
                        defaultMessage='Monthly salary'
                      />
                    </div>
                  )}
                  containerStyles={(values.monthlyIncome) ? styles.input : ''}
                />
                {values.monthlyIncome && (
                  <div className={styles.text}>
                    <FormattedMessage
                      id='step11.form.additionalIncome.monthlySalary.info'
                      defaultMessage='Salary for work of not less than 18 days. Per month'
                    />
                  </div>
                )}
              </div>
              <div className={styles.contentBlock}>
                <FieldCheckbox
                  fieldId={'additionalIncome'}
                  label={(
                    <div className={styles.text}>
                      <FormattedMessage
                        id='step11.form.additionalIncome.extraSalary.label'
                        defaultMessage='Extra salary'
                      />
                    </div>
                  )}
                  containerStyles={(values.additionalIncome) ? styles.input : ''}
                />
                {values.additionalIncome && (
                  <div className={styles.text}>
                    <FormattedMessage
                      id='step11.form.additionalIncome.extraSalary.info'
                      defaultMessage='Salary for work of more than 5 hours a day, in addition to salary and / or in addition to the taxable pension from another place. The employee may choose the workplace where his salary will be considered. "As" salary for an additional position'
                    />
                  </div>
                )}
              </div>
              <div className={styles.contentBlock}>
                <FieldCheckbox
                  fieldId={'partlyIncome'}
                  label={(
                    <div className={styles.text}>
                      <FormattedMessage
                        id='step11.form.additionalIncome.partlyIncome.label'
                        defaultMessage='Partial salary'
                      />
                    </div>
                  )}
                  containerStyles={(values.partlyIncome) ? styles.input : ''}
                />
                {values.partlyIncome && (
                  <div className={styles.text}>
                    <FormattedMessage
                      id='step11.form.additionalIncome.partlyIncome.info'
                      defaultMessage='Salary for work of 5 hours or less per day or salary for work for more than 5. Hours per day but less than 8 hours per week from a partial salary will be deducted tax at the maximum rate unless it is a single income then tax will be deducted according to.'
                    />
                  </div>
                )}
              </div>
              <div className={styles.contentBlock}>
                <FieldCheckbox
                  fieldId={'dailyWorkIncome'}
                  label={(
                    <div className={styles.text}>
                      <FormattedMessage
                        id='step11.form.additionalIncome.wages.label'
                        defaultMessage='Wages (daily worker)'
                      />
                    </div>
                  )}
                  containerStyles={(values.dailyWorkIncome) ? styles.input : ''}
                />
                {values.dailyWorkIncome && (
                  <div className={styles.text}>
                    <FormattedMessage
                      id='step11.form.additionalIncome.wages.info'
                      defaultMessage='Salary for work of less than 18 days. In a month but not less than 8 hours a week.'
                    />
                  </div>
                )}
              </div>
              <div className={styles.contentBlock}>
                <FieldCheckbox
                  fieldId={'allowance'}
                  label={(
                    <div className={styles.text}>
                      <FormattedMessage
                        id='step11.form.additionalIncome.allowance.label'
                        defaultMessage='Allowance'
                      />
                    </div>
                  )}
                  containerStyles={(values.allowance) ? styles.input : ''}
                />
                {values.allowance && (
                  <>
                    <div className={styles.text}>
                      <FieldCheckbox
                        fieldId={'allowanceBituahLeumi'}
                        label={(
                          <div className={styles.text}>
                            <FormattedMessage
                              id='step11.form.additionalIncome.allowanceBituahLeumi.label'
                              defaultMessage='Please detail'
                            />
                          </div>
                        )}
                        containerStyles={styles.input}
                      />
                    </div>
                    <div className={styles.text}>
                      <FieldCheckbox
                        fieldId={'allowancePension'}
                        label={(
                          <div className={styles.text}>
                            <FormattedMessage
                              id='step11.form.additionalIncome.allowancePension.label'
                              defaultMessage='Please detail'
                            />
                          </div>
                        )}
                      />
                    </div>
                  </>
                )}
              </div>
              <div className={styles.contentBlock}>
                <FieldCheckbox
                  fieldId={'scholarship'}
                  label={(
                    <div className={styles.text}>
                      <FormattedMessage
                        id='step11.form.additionalIncome.scholarship.label'
                        defaultMessage='Scholarship'
                      />
                    </div>
                  )}
                />
              </div>
              <div className={styles.contentBlock}>
                <FieldCheckbox
                  fieldId={'otherIncome'}
                  label={(
                    <div className={styles.text}>
                      <FormattedMessage
                        id='step11.form.additionalIncome.another.label'
                        defaultMessage='Another source'
                      />
                    </div>
                  )}
                  containerStyles={(values.otherIncome) ? styles.input : ''}
                />
                {values.otherIncome && (
                  <div className={styles.text}>
                    <FieldInput
                      fieldId={'otherIncomeFreeText'}
                      label={(
                        <div className={styles.text}>
                          <FormattedMessage
                            id='step11.form.additionalIncome.another.input.label'
                            defaultMessage='Please detail'
                          />
                        </div>
                      )}
                      placeholder={anotherIncomePlaceholder}
                      containerStyles={styles.input}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className={styles.contentBlock}>
              <div className={`${styles.headerWithExplanation} ${styles.input} `}>
                <div className={`${styles.title2}`}>
                  <FormattedMessage
                    id='step11.form.creditPoints.title'
                    defaultMessage='Credit points (optional)'
                  />
                </div>
              </div>
              <FieldRadiobutton
                fieldId={'creditPoints'}
                value={'noIncome'}
                label={(
                  <>
                    <p className={styles.text}>
                      <FormattedMessage
                        id='step11.form.creditPoints.radio.noOtherIncome'
                        defaultMessage='I will apply for credit points and tax brackets. (Against my income) (my income from this employer. I do not receive them in any other income).'
                      />
                    </p>
                    <div className={styles.smallText}>
                      <FormattedMessage
                        id='step11.form.creditPoints.radio.noOtherIncome.details'
                      />
                    </div>
                  </>
                )}
                containerStyles={styles.input}
              />
              <FieldRadiobutton
                fieldId={'creditPoints'}
                value={'forThisIncome'}
                label={(
                  <>
                    <p className={styles.text}>
                      <FormattedMessage
                        id='step11.form.creditPoints.radio.otherIncome'
                        defaultMessage='I receive credit points and tax brackets on other income and therefore I am not entitled to them against that income.'
                      />
                    </p>
                    <div className={styles.smallText}>
                      <FormattedMessage
                        id='step11.form.creditPoints.radio.otherIncome.details'
                      />
                    </div>
                  </>
                )}
                containerStyles={styles.input}
              />
            </div>
            <div className={`${styles.contentBlock} ${styles.input}`}>
              <div className={`${styles.title2} ${styles.input}`}>
                <FormattedMessage
                  id='step11.form.secretions.title'
                  defaultMessage='Secretions'
                />
              </div>
              <FieldCheckbox
                fieldId={'secretionSavings'}
                label={(
                  <>
                    <p className={styles.text}>
                      <FormattedMessage
                        id='step11.form.secretions.study.label'
                        defaultMessage='No provisions are made for me in the study fund in respect of my other income, or all the employers contributions in the study fund in respect of my other income are attached to my other income.'
                      />
                    </p>
                    <div className={styles.smallText}>
                      <FormattedMessage
                        id='step11.form.secretions.study.details'
                      />
                    </div>
                  </>
                )}
                containerStyles={styles.input}
              />
              <FieldCheckbox
                fieldId={'secretionInsurance'}
                label={(
                  <>
                    <p className={styles.text}>
                      <FormattedMessage
                        id='step11.form.secretions.insurance.label'
                        defaultMessage='There are no provisions for me for an annuity / loss insurance, work capacity / compensation for my other income or any provisions of the employer for an annuity / for loss of ability to work / compensation for my income. The other is attached to my other income.'
                      />
                    </p>
                    <div className={styles.smallText}>
                      <FormattedMessage
                        id='step11.form.secretions.insurance.details'
                      />
                    </div>
                  </>
                )}
                containerStyles={styles.input}
              />
            </div>
          </>
        )
      }
      <div className={styles.innerPadding}>
        <Button
          type='submit'
          label={(
            <FormattedMessage
              id='common.form.button.save'
              defaultMessage='Save'
            />
          )}
        />
        {!isValid && <ErrorValidation/>}
      </div>
    </Form>
  )
};

Step11View.propTypes = {
  values: PropTypes.object,
  isValid: PropTypes.bool,
};

export default Step11View;
